import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

export default function FAQ({ items = [], testIdPrefix = "faq", theme = "light" }) {
  const isDark = theme === "dark";
  return (
    <div className="pt-16">
      <p
        className="section-number mb-6"
        style={isDark ? { color: "rgba(250,250,247,0.6)" } : undefined}
      >
        FAQ
      </p>
      <Accordion type="single" collapsible className="w-full">
        {items.map((item, idx) => (
          <AccordionItem
            key={idx}
            value={`item-${idx}`}
            className="border-b"
            style={{
              borderColor: isDark
                ? "rgba(250,250,247,0.12)"
                : "var(--border-soft)",
            }}
          >
            <AccordionTrigger
              className="text-left font-display text-[20px] md:text-[24px] py-6 hover:no-underline"
              style={{ fontWeight: 500, color: isDark ? "var(--canvas)" : "var(--ink)" }}
              data-testid={`${testIdPrefix}-q-${idx}`}
            >
              {item.q}
            </AccordionTrigger>
            <AccordionContent
              className="text-[15px] leading-relaxed pb-6 max-w-[760px]"
              style={{ color: isDark ? "rgba(250,250,247,0.78)" : "var(--ink-secondary)" }}
              data-testid={`${testIdPrefix}-a-${idx}`}
            >
              {item.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
